import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../components/form/FormInputText";
import CdoOpcCommand from "./CdoOpcCommand";
// INTERFACES
import {
	OpcMappingsInterface,
	OpcCommandType,
	OpcCmdToSequenceInterface,
	OpcCommandTableInterface,
	ResponseContentTypesInterface,
	ReadContentTypesInterface,
	WriteContentTypesInterface,
	OpcCommand,
} from "../../../../../interfaces/AdapterCdoOpc.interface";

export default function CdoOpcMappingOpcCmdToSequence({
	setValue,
	opcMapping,
}: {
	setValue: (newValue: any) => void;
	opcMapping: OpcMappingsInterface;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [opcCmdToSequence, setOpcCmdToSequence] = useState<{
		command: OpcCommand;
		opcCommand: OpcCommandType;
		address: string;
		description: string;
		msg_id: string;
		active: boolean;
		position: number;
		responseContentType: ResponseContentTypesInterface;
		readContentType: ReadContentTypesInterface;
		writeContentType: WriteContentTypesInterface;
	}>({
		command: {},
		opcCommand: "read_content_table",
		address: "",
		description: "",
		msg_id: "",
		active: true,
		position: 0,
		responseContentType: "read_item_response",
		readContentType: "read_sync_item_message",
		writeContentType: "make_group",
	});
	const [opcCmdToSequenceValue, setOpcCmdToSequenceValue] = useState<{
		command: OpcCommand;
		opcCommand: OpcCommandType;
		address: string;
		description: string;
		msg_id: string;
		active: boolean;
		position: number;
		responseContentType: ResponseContentTypesInterface;
		readContentType: ReadContentTypesInterface;
		writeContentType: WriteContentTypesInterface;
	}>({
		command: {},
		opcCommand: "read_content_table",
		address: "",
		description: "",
		msg_id: "",
		active: true,
		position: 0,
		responseContentType: "read_item_response",
		readContentType: "read_sync_item_message",
		writeContentType: "make_group",
	});
	const [opcCmdToSequenceValues, setOpcCmdToSequenceValues] = useState<
		OpcCommandTableInterface[]
	>([]);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickAddNewOpcCmdToSequenceValue = () => {
		const copy = structuredClone(opcCmdToSequenceValues);
		copy.push({
			command: {
				[opcCmdToSequenceValue.opcCommand]:
					opcCmdToSequenceValue.command.read_content_table ||
					opcCmdToSequenceValue.command.response_content_table ||
					opcCmdToSequenceValue.command.write_content_table,
			},
		});
		setOpcCmdToSequenceValues(copy);
		setOpcCmdToSequenceValue({
			...opcCmdToSequenceValue,
			opcCommand: "read_content_table",
			address: "",
			description: "",
		});
	};

	const onChangeOpcCmdToSequence = (
		newValue: string | boolean,
		variableName: string,
	) => {
		const copy = structuredClone(opcCmdToSequence);
		if (variableName === "address" && typeof newValue === "string") {
			copy.address = newValue;
		} else if (variableName === "description" && typeof newValue === "string") {
			copy.description = newValue;
		} else if (
			variableName === "addressValue" &&
			typeof newValue === "string"
		) {
			copy.address = newValue;
		} else if (
			variableName === "descriptionValue" &&
			typeof newValue === "string"
		) {
			copy.description = newValue;
		}
		setOpcCmdToSequence(copy);
	};

	const onClickAddNewOpcCmdToSequence = () => {
		const newOpcCmdToSequence: OpcCmdToSequenceInterface = {
			key: {
				[opcCmdToSequence.opcCommand]:
					opcCmdToSequence.command.read_content_table ||
					opcCmdToSequence.command.response_content_table ||
					opcCmdToSequence.command.write_content_table,
			},
			value: opcCmdToSequenceValues,
		};
		const copy = structuredClone(opcMapping);
		copy.opc_cmd_to_sequence.push(newOpcCmdToSequence);
		setValue(copy);
		setOpcCmdToSequence({
			command: {},
			opcCommand: "read_content_table",
			address: "",
			description: "",
			msg_id: "",
			active: true,
			responseContentType: "read_item_response",
			readContentType: "read_sync_item_message",
			writeContentType: "add_item",
			position: 0,
		});
		setOpcCmdToSequenceValues([]);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<CdoOpcCommand
				setOpcCommand={setOpcCmdToSequence}
				opcCommand={opcCmdToSequence}
			/>
			<FormInputText
				inputValue={opcCmdToSequence.address}
				inputLabelName={t("general.address")}
				inputOnChange={onChangeOpcCmdToSequence}
				inputVariableName='address'
				isRequired
				disabledInput={false}
				
			/>
			<FormInputText
				inputValue={opcCmdToSequence.description}
				inputLabelName={t("general.description")}
				inputOnChange={onChangeOpcCmdToSequence}
				inputVariableName='description'
				isRequired
				disabledInput={false}
				
			/>
			<CdoOpcCommand
				setOpcCommand={setOpcCmdToSequenceValue}
				opcCommand={opcCmdToSequenceValue}
			/>
			<FormInputText
				inputValue={opcCmdToSequenceValue.address}
				inputLabelName={`Value ${t("general.address")}`}
				inputOnChange={onChangeOpcCmdToSequence}
				inputVariableName='addressValue'
				isRequired
				disabledInput={false}
				
			/>
			<FormInputText
				inputValue={opcCmdToSequenceValue.description}
				inputLabelName={`Value ${t("general.description")}`}
				inputOnChange={onChangeOpcCmdToSequence}
				inputVariableName='descriptionValue'
				isRequired
				disabledInput={false}
				
			/>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired'>*</span>
						<span className='drawer__text'>{t("general.preview")}</span>
					</div>
					<div className='generalStyles__width100'>
						{opcCmdToSequenceValues.map(
							(item: OpcCommandTableInterface, index: number) => {
								const { command } = item;
								let commandType = "";
								let commandData: any;
								if (command.read_content_table) {
									commandType = "read_content_table";
									commandData = command.read_content_table;
								} else if (command.write_content_table) {
									commandType = "write_content_table";
									commandData = command.write_content_table;
								} else if (command.response_content_table) {
									commandType = "response_content_table";
									commandData = command.response_content_table;
								}
								return (
									<div
										key={index}
										style={{
											marginBottom: "12px",
											backgroundColor: "#1f1f1f",
											padding: "10px",
											borderRadius: "5px",
											fontSize: "10px",
										}}
									>
										<div>
											<span
												className='generalStyles__info'
												style={{ fontWeight: "bold" }}
											>
												Command:{" "}
											</span>
											<span>{commandType.replace(/_/g, " ") || "—"}</span>
										</div>
										<div>
											<span
												className='generalStyles__info'
												style={{ fontWeight: "bold" }}
											>
												Description:{" "}
											</span>
											<span>
												{commandData && "description" in commandData
													? commandData.description
													: "—"}
											</span>
										</div>
										<div>
											<span
												className='generalStyles__info'
												style={{ fontWeight: "bold" }}
											>
												Address:{" "}
											</span>
											<span>
												{commandData && "address" in commandData
													? commandData.address
													: "—"}
											</span>
										</div>
									</div>
								);
							},
						)}
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired' />
					</div>
					<div className='generalStyles__width100'>
						<Button
							disabled={
								opcCmdToSequenceValue.address === "" ||
								opcCmdToSequenceValue.description === ""
							}
							onClick={onClickAddNewOpcCmdToSequenceValue}
							className={`generalStyles__width100 ${
								opcCmdToSequenceValue.address === "" ||
								opcCmdToSequenceValue.description === ""
									? ""
									: "buttonStyle__28"
							}`}
						>
							<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />
							{t("general.addNewValue")}
						</Button>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired' />
					</div>
					<div className='generalStyles__width100'>
						<Button
							disabled={
								opcCmdToSequence.address === "" ||
								opcCmdToSequence.description === ""
							}
							onClick={onClickAddNewOpcCmdToSequence}
							className={`generalStyles__width100 ${
								opcCmdToSequence.address === "" ||
								opcCmdToSequence.description === ""
									? ""
									: "buttonStyle__28"
							}`}
						>
							<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />
							{t("general.add")}
						</Button>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
		</div>
	);
}
